<template>
  <base-select-vehicle @close="closeSelectVehicle" :open="openDialog === true" @selectedVehicleComplete="selectedVehicleComplete">
	</base-select-vehicle>
  <!-- site__mobile-header -->
  <header class="site__mobile-header modal-open">
    <div class="mobile-header">
      <div class="container">
        <div class="mobile-header__body">
          <button class="mobile-header__menu-button" type="button" @click="mobileMenuOpen = !mobileMenuOpen">
            <svg width="18px" height="14px">
              <path d="M0,8V6h18v2H0z M0,0h18v2H0V0z" />
              <rect y="12" width="18" height="2" />
            </svg>
          </button>
          <router-link class="mobile-header__logo" to="/">
            <!--<a class="mobile-header__logo" href="/index">-->
            <!-- mobile-logo -->
            <div class="logo__image">
              <img :src="$store.getters.mobile_logo" alt="" />
            </div>
            <!-- mobile-logo / end -->
            <!--</a>-->
          </router-link>
          <div class="mobile-header__search mobile-search">
            <form class="mobile-search__body">
              <input
                type="text"
                class="mobile-search__input input--mobile-autocomplete"
                placeholder="Enter keyword or part number" v-model="searchkeyword" 
                @keypress.enter="keywordMobSearch"
                @keyup.up="up"
                @keyup.down="down"
                @input = 'change'
              />
              <ul class="dropdown-menu" style="width:100%" v-bind:class="{'open':openSuggestion}">
                  <li v-for="(suggestion, index) in api_results" :key="index" 
                  v-bind:class="{'active': isActive(index)}"
                  @click="suggestionClick(suggestion)">
                      <a href="#" class="notranslate">{{ suggestion }}</a>
                  </li>
              </ul>
              <button type="button" class="mobile-search__vehicle-picker" v-if="has_search_vehicle == true" aria-label="Select Vehicle" @click="openSelectVehicle">
                <svg width="20" height="20">
                  <path
                    d="M6.6,2c2,0,4.8,0,6.8,0c1,0,2.9,0.8,3.6,2.2C17.7,5.7,17.9,7,18.4,7C20,7,20,8,20,8v1h-1v7.5c0,0.8-0.7,1.5-1.5,1.5h-1 	c-0.8,0-1.5-0.7-1.5-1.5V16H5v0.5C5,17.3,4.3,18,3.5,18h-1C1.7,18,1,17.3,1,16.5V16V9H0V8c0,0,0.1-1,1.6-1C2.1,7,2.3,5.7,3,4.2 	C3.7,2.8,5.6,2,6.6,2z M13.3,4H6.7c-0.8,0-1.4,0-2,0.7c-0.5,0.6-0.8,1.5-1,2C3.6,7.1,3.5,7.9,3.7,8C4.5,8.4,6.1,9,10,9 	c4,0,5.4-0.6,6.3-1c0.2-0.1,0.2-0.8,0-1.2c-0.2-0.4-0.5-1.5-1-2C14.7,4,14.1,4,13.3,4z M4,10c-0.4-0.3-1.5-0.5-2,0 	c-0.4,0.4-0.4,1.6,0,2c0.5,0.5,4,0.4,4,0C6,11.2,4.5,10.3,4,10z M14,12c0,0.4,3.5,0.5,4,0c0.4-0.4,0.4-1.6,0-2c-0.5-0.5-1.3-0.3-2,0 	C15.5,10.2,14,11.3,14,12z"
                  />
                </svg>
                <span class="mobile-search__vehicle-picker-label">{{catclass}} Search
                </span>
              </button>
              <button type="submit" class="mobile-search__button mobile-search__button--search" @click.prevent="keywordSearch">
                <svg width="20" height="20">
                  <path
                    d="M19.2,17.8c0,0-0.2,0.5-0.5,0.8c-0.4,0.4-0.9,0.6-0.9,0.6s-0.9,0.7-2.8-1.6c-1.1-1.4-2.2-2.8-3.1-3.9C10.9,14.5,9.5,15,8,15 	c-3.9,0-7-3.1-7-7s3.1-7,7-7s7,3.1,7,7c0,1.5-0.5,2.9-1.3,4c1.1,0.8,2.5,2,4,3.1C20,16.8,19.2,17.8,19.2,17.8z M8,3C5.2,3,3,5.2,3,8 	c0,2.8,2.2,5,5,5c2.8,0,5-2.2,5-5C13,5.2,10.8,3,8,3z"
                  />
                </svg>
              </button>
              <button
                type="button"
                class="mobile-search__button mobile-search__button--close"
              >
                <svg width="20" height="20">
                  <path
                    d="M16.7,16.7L16.7,16.7c-0.4,0.4-1,0.4-1.4,0L10,11.4l-5.3,5.3c-0.4,0.4-1,0.4-1.4,0l0,0c-0.4-0.4-0.4-1,0-1.4L8.6,10L3.3,4.7 	c-0.4-0.4-0.4-1,0-1.4l0,0c0.4-0.4,1-0.4,1.4,0L10,8.6l5.3-5.3c0.4-0.4,1-0.4,1.4,0l0,0c0.4,0.4,0.4,1,0,1.4L11.4,10l5.3,5.3 	C17.1,15.7,17.1,16.3,16.7,16.7z"
                  />
                </svg>
              </button>
              <div class="mobile-search__field"></div>
            </form>
          </div>
          <div class="mobile-header__indicators">
            <div class="mobile-indicator mobile-indicator--search d-md-none">
              <button type="button" class="mobile-indicator__button">
                <span class="mobile-indicator__icon">
                  <svg width="80" height="20" x="0px" y="10px">
                    <!--<style type="text/css">	.st1{font-size:14px;} 
                      </style>-->
                    <path
                      d="M19.2,17.8c0,0-0.2,0.5-0.5,0.8c-0.4,0.4-0.9,0.6-0.9,0.6s-0.9,0.7-2.8-1.6c-1.1-1.4-2.2-2.8-3.1-3.9 		C10.9,14.5,9.5,15,8,15c-3.9,0-7-3.1-7-7s3.1-7,7-7s7,3.1,7,7c0,1.5-0.5,2.9-1.3,4c1.1,0.8,2.5,2,4,3.1 		C20,16.8,19.2,17.8,19.2,17.8z M8,3C5.2,3,3,5.2,3,8s2.2,5,5,5s5-2.2,5-5S10.8,3,8,3z"
                    />
                    <text
                      transform="matrix(1 0 0 1 19.4971 12.0435)"
                      class="st1"
                    >
                      Search
                    </text>
                  </svg>
                </span>
              </button>
            </div>
            <div>
              <img src="images/spacer.png" width="18px" />
            </div>
            <div class="mobile-indicator">
              <router-link to="/login" class="mobile-indicator__button loginbtn" v-if="!isLoggedIn">
                <span class="mobile-indicator__icon">
                  <svg width="80" height="20">
                    <!--<style type="text/css">	.st1{font-size:14px;} 
                      </style>-->
                    <text
                      transform="matrix(1 0 0 1 17.4971 12.0435)"
                      class="st1"
                    >
                      Log In
                    </text>
                  </svg>
                </span>
              </router-link>
            </div>
            <div class="mobile-indicator">
              <router-link to="/cart" class="mobile-indicator__button">
                <span class="mobile-indicator__icon">
                  <svg width="20" height="20">
                    <circle cx="7" cy="17" r="2" />
                    <circle cx="15" cy="17" r="2" />
                    <path
                      d="M20,4.4V5l-1.8,6.3c-0.1,0.4-0.5,0.7-1,0.7H6.7c-0.4,0-0.8-0.3-1-0.7L3.3,3.9C3.1,3.3,2.6,3,2.1,3H0.4C0.2,3,0,2.8,0,2.6 	V1.4C0,1.2,0.2,1,0.4,1h2.5c1,0,1.8,0.6,2.1,1.6L5.1,3l2.3,6.8c0,0.1,0.2,0.2,0.3,0.2h8.6c0.1,0,0.3-0.1,0.3-0.2l1.3-4.4 	C17.9,5.2,17.7,5,17.5,5H9.4C9.2,5,9,4.8,9,4.6V3.4C9,3.2,9.2,3,9.4,3h9.2C19.4,3,20,3.6,20,4.4z"
                    />
                  </svg>
                  <span class="mobile-indicator__counter">{{cartquantity}}</span>
                </span>
              </router-link>
            </div>
          </div>
        </div>
      </div>
    </div>
  </header>
  <!-- site__mobile-header / end -->
  <!-- site__header -->
  <header class="site__header">
    <div class="header">
      <div class="header__navbar">       
        <primary-category :industrial_menus="industrialCat" :level1="level1" @select_vehicle="select_vehicle"></primary-category>

        <div class="header__navbar-menu">
          <main-menu :menus="menus" ></main-menu>
        </div>
      </div>
      <div class="header__logo">
        <!--<a href="/index" class="logo">-->
        <router-link class="logo" to="/">
          <div class="logo__slogan">
            Auto parts for Cars, trucks and motorcycles
          </div>
          <div class="logo__image">
            <!-- desktop image / logo -->
            <div class="logo__image">
              <img :src="$store.getters.desktop_logo" alt="" />
            </div>
            <!-- desktop image / logo end -->
          </div>
        </router-link>
        <!--</a>-->
      </div>
      <header-search @selectedVehicleComplete="selectedVehicleComplete"></header-search>
      <div class="header__indicators">
        <account-info></account-info>
        <shopping-cart></shopping-cart>  
      </div>
    </div>
  </header>
  <div class="header-message-bar" v-if="headerMsg != ''">
		<div class="message-bar-announcement">
      <a href="#" @click="headerLink">
        <!-- <strong>Shipping Update</strong>   Find Out More -->
          {{headerMsg}}
      </a>
    </div>
	</div>
  <!-- site__header / end -->
  <mobile-menu :level1="level1" :menus="menus" :industrial_menus="industrialCat" :isOpen="mobileMenuOpen" @closeMenu="closeMobMenu()"
    @select_vehicle="select_vehicle()">

  </mobile-menu>
  <!-- mobile-menu / end -->
  <!-- quickview-modal -->
  <div
    id="quickview-modal"
    class="modal fade"
    tabindex="-1"
    role="dialog"
    aria-hidden="true"
  ></div>
  <!-- photoswipe -->
  <div class="pswp" tabindex="-1" role="dialog" aria-hidden="true">
    <div class="pswp__bg"></div>
    <div class="pswp__scroll-wrap">
      <div class="pswp__container">
        <div class="pswp__item"></div>
        <div class="pswp__item"></div>
        <div class="pswp__item"></div>
      </div>
      <div class="pswp__ui pswp__ui--hidden">
        <div class="pswp__top-bar">
          <div class="pswp__counter"></div>
          <button
            class="pswp__button pswp__button--close"
            title="Close (Esc)"
          ></button>
          <!--<button class="pswp__button pswp__button&#45;&#45;share" title="Share"></button>-->
          <button
            class="pswp__button pswp__button--fs"
            title="Toggle fullscreen"
          ></button>
          <button
            class="pswp__button pswp__button--zoom"
            title="Zoom in/out"
          ></button>
          <div class="pswp__preloader">
            <div class="pswp__preloader__icn">
              <div class="pswp__preloader__cut">
                <div class="pswp__preloader__donut"></div>
              </div>
            </div>
          </div>
        </div>
        <div
          class="pswp__share-modal pswp__share-modal--hidden pswp__single-tap"
        >
          <div class="pswp__share-tooltip"></div>
        </div>
        <button
          class="pswp__button pswp__button--arrow--left"
          title="Previous (arrow left)"
        ></button>
        <button
          class="pswp__button pswp__button--arrow--right"
          title="Next (arrow right)"
        ></button>
        <div class="pswp__caption">
          <div class="pswp__caption__center"></div>
        </div>
      </div>
    </div>
  </div>

  <div class="modal-backdrop fade show" v-if="vehicleModalOpen"></div>
</template>

<script>
import axiosvl from "../../axios/axios-vl.js";
import { mapGetters } from 'vuex';
import MainMenu from "./menu/MainMenu.vue";
import MobileMenu from "./menu/MobileMenu.vue";
import AccountInfo from "./accountinfo/AccountInfo.vue";
import ShoppingCart from "./shoppingcart/ShoppingCart.vue";
import HeaderSearch from "./search/HeaderSearch.vue";
import PrimaryCategory from "./category/PrimaryCategory.vue";
import VehicleSearch from '../../mixins/vehicle_search.js';
// import { sfCustom } from '../../utilities/customs';

export default {
  components: {
    "main-menu": MainMenu,
    "account-info": AccountInfo,
    "shopping-cart": ShoppingCart,
    "header-search": HeaderSearch,
    "primary-category": PrimaryCategory,
    "mobile-menu": MobileMenu,
  },
  mixins: [VehicleSearch],

  computed:{
    cartquantity() {
        let totalquantity = 0;
        for (let x in this.cart) {
            totalquantity += parseInt(this.cart[x].quantity);
        }
        return totalquantity;
    },
    ...mapGetters("cart", [
        "cart",
        "totals",
    ]),
    ...mapGetters([
        'storefrontAttributes',
        "appInitialiazed",
        "storefront",
        "userIsAuthenticated"
    ]),
    ...mapGetters("vehicle", [
        "selectedyear",
        "selectedmake",
        "selectedmodel",
        "selectedengine",
    ]),

    ...mapGetters('api', [
        "catclass",
    ]),

    has_search_vehicle() {
      if(this.storefront){
        // return sfCustom[this.storefront].search_vehicle;
        return process.env.VUE_SEARCH_VEHICLE;
      }
      return false;
    },

    headerMsg(){
      if(this.storefrontAttributes.length == 0){
        return '';
      }
      return this.storefrontAttributes.find(attribute => attribute.type === 'SIM').value;
    },

    headerURI(){
      if(this.storefrontAttributes.length == 0){
        return '';
      }
      const MSL = this.storefrontAttributes.find(attribute => attribute.type === 'MSL').value;
      return MSL;
    },

    //The flag
    openSuggestion() {
        return this.api_results.length != 0 &&
            this.openMobSearchParts === true;
    }
  },

  watch: {
    appInitialiazed(newVal){
      if(newVal == true){
        this.getCategories();
        this.getMenus();
        this.getIndustrialCat();
        // method from search mixins
        this.getYears();
      }
    },
    userIsAuthenticated(newVal){
      // console.log('userIsAuthenticated = ' + newVal);
      this.isLoggedIn = newVal;
    }
  },

  data() {
    return {
      isLoggedIn : false,
      categories: [],
      level1: [],
      isloading: false,
      menus: [],
      industrialCat: [],

      mobileMenuOpen: false,
      
      selectedyear: 0,
      selectedmake: '',
      selectedmodel: '',
      selectedengine: '',
      years: [],
      makes: [],
      models: [],
      engines: [],
      searchvalid: null,
      searchkeyword: '',
      vehiclewasselected: false,

      parentURI: null,
      childURI: null,

      vehicleModalOpen: false,
      openDialog: false,

      // data for auto complete
      openMobSearchParts: false,
      currentMobSearchParts: 0,
      selectedMobSearchParts: null,
      api_results: [],
    }
  },

  methods: {
    getCategories() {
      this.isloading = true;
      this.categories = [];
      let DMCD01_DSVEH = [];
      // const url =
      //   "/D15PGMLIB/lansaweb?w=category&r=categories&vlweb=1&part=" +
      //   this.$store.getters["system/erppartition"] +
      //   "&lang=" +
      //   this.$store.getters["system/language"] +
      //   "&_T=1611072351543";
      const category_uri = this.$store.getters['api/menu_categories_uri'];

      axiosvl.post(category_uri, {
          webroutine: {
            context: {
              "session-key-method": "hidden",
            },
            fields: {
              EHCUST: {
                value: this.$store.getters['customer'],
              },
              SKIPSTART: {
                value: "-",
              },
            },
          },
        })
        .then((response) => {
          const results = [];
          for (const key in response.data.webroutine.lists.CATTREE.entries) {
            const obj = response.data.webroutine.lists.CATTREE.entries[key];

            if(obj.DSVEH == 'Y' && obj.DMCD02 == ''){
              DMCD01_DSVEH.push(obj.DMCD01);
            }
            

            results.push({
              CATTREEL: obj.CATTREEL,
              categorycode: obj.CATTCODE,
              categoryname: obj.CATNAME.replaceAll("&amp;", "&"),
              categorylevel: obj.CATLEVEL,
              CATLNAME: obj.CATLNAME,
              TKEY: obj.TKEY,
              TPARENT: obj.TPARENT,
              DMCD01: obj.DMCD01,
              DMCD02: obj.DMCD02,
              DMCD03: obj.DMCD03,
              DMCD04: obj.DMCD04,
              DMCD05: obj.DMCD05,
              DMCD06: obj.DMCD06,
              DMCD07: obj.DMCD07,
              DMCD08: obj.DMCD08,
              DMCD09: obj.DMCD09,
              DMCD10: obj.DMCD10,
              categorydiagramimage: obj.DTIMAG,
              DSVEH: obj.DSVEH
            });
          }

          this.categories = results;
          
          // console.table(response.data.webroutine.lists.CATTREE.entries);

          let level1 = this.categories.filter((lvl) => lvl.categorylevel === 1).sort((a,b) => (a.categoryname > b.categoryname) ? 1 : ((b.categoryname > a.categoryname) ? -1 : 0));
          let level2 = this.categories.filter((lvl) => lvl.categorylevel === 2 && (DMCD01_DSVEH.find(d => d == lvl.DMCD01) == undefined));
          let level3 = this.categories.filter((lvl) => lvl.categorylevel === 3);

          // console.table(level2);

          level1.forEach(
            (lvl1) =>
              (lvl1.subcategories = level2.filter(
                (lvl2) => lvl2.DMCD01 === lvl1.DMCD01
              )).sort((a,b) => (a.categoryname > b.categoryname) ? 1 : ((b.categoryname > a.categoryname) ? -1 : 0))
          );

          level1.forEach((lvl1) =>
            lvl1.subcategories.forEach(
              (lvl2) =>
                (lvl2.subcategories = level3.filter(
                  (lvl3) =>
                    lvl3.DMCD01 === lvl2.DMCD01 && lvl3.DMCD02 === lvl2.DMCD02
                ))
            )
          );

          level1.forEach(function (lvl1) {
            lvl1.hassubs = lvl1.subcategories.filter(
              (lvl2) => lvl2.subcategories.length > 0
            );
            lvl1.blanksubs = lvl1.subcategories.filter(
              (lvl2) => lvl2.subcategories.length == 0
            );
          });

          this.level1 = level1;
          this.isloading = false;

          // push the categories to state
          this.$store.dispatch("product/setCategories", results);
          this.$store.dispatch("product/setFormatCategories", this.level1);
        })
        .catch(function (error) {
          console.error("error - " + error);
          this.isloading = false;
        });
    },

    getMenus() {
      const menu_uri = this.$store.getters['api/menu_uri'];
      axiosvl.post(menu_uri, {
          webroutine: {
            context: {
              "session-key-method": "hidden",
            },
            fields: {
              LW3SFID: {
                value: this.$store.getters.storefront,
              },
            },
          },
      }).then((response) => {
        const results = [];

        for (const key in response.data.webroutine.lists.LS_MENU.entries) {
          const obj = response.data.webroutine.lists.LS_MENU.entries[key];
          results.push({
            menuid: obj.LW3MNUID,
            parentmenuid: obj.LW3MNUPID,
            menuname: obj.LW3MNUNME,
            menuorder: obj.LW3MNUORD,
            linktype: obj.LW3LNKTYP,
            primary: obj.LW3PRMMNU,
            url: obj.LW3MNUURL,
            pgm: obj.LW3MNUPGM,
            hassubmenu: obj.LW3HSSUBF,
          });
        }
        this.menus = results;
        // console.table(this.menus);
      })
      .catch(function (error) {
        console.error(error);
      });
    },

    async getIndustrialCat() {
      const sfCatalog = this.$store.getters['storeCatalog'];
      const catpn = this.$store.getters['storeConfigID'];

      if(sfCatalog.toUpperCase() == 'WHI'){
        this.parentURI = this.$store.getters['api/vehicle_group_uri'];
        this.childURI = this.$store.getters['api/vehicle_categoriesM_uri'];
      }else{
        this.parentURI = this.$store.getters['api/vehicle_group_uri'];
        this.childURI = this.$store.getters['api/vehicle_typeM_uri'];
      }

      // CATPN 
      if(!catpn){
        return;
      }

      await axiosvl.post(this.parentURI, {
        webroutine: {
          context: {
            "session-key-method": "hidden",
          },
          fields: {
            EHCUST: {
              value: this.$store.getters.customer,
            },
            CATPN: {"value": catpn}
          },
        },
      })
      .then((response) => {
          const groups = [];
          const paramgroups = [];
          for (const key in response.data.webroutine.lists.GROUPSD.entries) {
            const obj = response.data.webroutine.lists.GROUPSD.entries[key];
            groups.push({
              QGROUP: obj.QGROUP,
              QGRDSC: obj.QGRDSC,
              QGRDSCR: obj.QGRDSCR,
              SUBCAT: []
            });
            paramgroups.push([obj.QGROUP]);
          }

          // this.getIndustrialChild(paramgroups).then((resdata) => {
          //     let children = []; 
          //     for (const i in resdata.data.webroutine.lists.CATSD.entries) {
          //       const obj2 = resdata.data.webroutine.lists.CATSD.entries[i];
          //       children.push({
          //           QCAENR: obj2.QCAENR,
          //           QCAT: obj2.QCAT,
          //           QGRDSC: obj2.QGRDSC,
          //           QGRDSCR: obj2.QGRDSCR,
          //           QGROUP: obj2.QGROUP,
          //         });
          //     }
              
          //     groups.forEach((item) => {
          //       item.SUBCAT = children.filter(child => (child.QGROUP === item.QGROUP));
          //     });
          //     // groups.push({
          //     //   QGROUP: obj.QGROUP,
          //     //   QGRDSC: obj.QGRDSC,
          //     //   QGRDSCR: obj.QGRDSCR,
          //     //   SUBCAT: children
          //     // });
          //   });

          this.industrialCat = groups;

          this.$store.dispatch('product/setIndustrialCategories', groups);
      })
      .catch(function (error) {
        console.error("error - " + error);
        // this.isloading = false;
      });
    },

    async getIndustrialChild(paramgroups) {
      const catpn = this.$store.getters['storeConfigID'];

      return await axiosvl.post(this.childURI, {
        webroutine: {
          context: {
            "session-key-method": "hidden",
          },
          fields: {
            EHCUST: {
              value: this.$store.getters.customer,
            },
            CATPN: {"value": catpn},
          },
          lists: {
            "GROUPSI": {
                "header": [
                    {"name": "QGROUP"}
                ],
                "entries": paramgroups
            }
          }
        },
      })
      .then((response) => {
          return response;
      })
      .catch(function (error) {
        console.error("error - " + error);
        this.isloading = false;
      });
    },

    searchParts() {
      this.searchvalid = true;

      if (this.selectedyear === 0 || this.selectedmake === '' || this.selectedmodel === '') {
        this.searchvalid = false;
      }
      if (this.storeCatalog === 'WHI') {
        if (this.selectedengine === '') {
          this.searchvalid = false;
        }
      }

      if (this.searchvalid) {
        this.$store.dispatch("vehicle/setSelectedVehicle", { "selectedvehicle": 0 });
        this.$store.dispatch("vehicle/setSelectedYear", { "selectedyear": this.selectedyear });
        this.$store.dispatch("vehicle/setSelectedMake", { "selectedmake": this.selectedmake, "desc": this.makes.find(make => make.make === this.selectedmake).desc });
        this.$store.dispatch("vehicle/setSelectedModel", { "selectedmodel": this.selectedmodel, "desc": this.models.find(model => model.model === this.selectedmodel).desc });
        this.$store.dispatch("vehicle/setSelectedEngine", { "selectedengine": this.selectedengine, "desc": this.engines.find(engine => engine.engine === this.selectedengine).desc });
      
        this.$router.push("/search-results");

        this.vehicleModalOpen = false;
      }
    },

    closeMobMenu() {
      this.mobileMenuOpen = false;
    },

    select_vehicle() {
      // this.vehicleModalOpen = true;
      this.openDialog = true;
      this.mobileMenuOpen = false;
    },

    keywordSearch() {
      this.$router.push('/keyword-search-results/' + this.searchkeyword);
    },

		openSelectVehicle() {
			this.openDialog = true;
		},
		closeSelectVehicle() {
			this.openDialog = false;
		},

    headerLink() {
      const MSL = this.storefrontAttributes.find(attribute => attribute.type === 'MSL').value;
      this.$router.push(MSL);
    },

    /**
     * Autocomplete suggestions methods
     */

    // to call the api to search string
    search_typeahed() {

        if (this.searchkeyword == ''){
            return false;
        }

        axiosvl.post(this.$store.getters['api/search_typeahead_uri'], 
          {
            "webroutine": {
              "context": {
                "session-key-method": "hidden"
              },
              "fields": {
                "EHCUST": {
                  "value": this.$store.getters.customer
                  // "value": "DMS"
                },
                "TYPEAHEAD" : {
                    "value": this.searchkeyword
                }
              }
            }
          }
        ).then((response) => { 
          const fields = response.data.webroutine.fields;
          this.api_results = [];
          for (const key in response.data.webroutine.lists.PDESCS.entries) { 
            const obj = response.data.webroutine.lists.PDESCS.entries[key];
            this.api_results.push(obj.TADESCR);	
          }

          if (fields.NREC.value > 0){
              this.openMobSearchParts = true;
          }

        }).catch(function (error) { 
          console.error("error - " + error);
        });
    },

    //When up pressed while suggestions are open
    up() {
        if(this.currentMobSearchParts > 0)
            this.currentMobSearchParts--;
    },

    //When up pressed while suggestions are open
    down() {
        if(this.currentMobSearchParts < this.api_results.length - 1)
            this.currentMobSearchParts++;
    },

    //For highlighting element
    isActive(index) {
        return index === this.currentMobSearchParts;
    },

    //When the user changes input
    change() {
        // console.log('change');
        this.search_typeahed();
        if (this.openMobSearchParts == false) {
            this.openMobSearchParts = true;
            this.currentMobSearchParts = 0;
        }
    },

    //When one of the suggestion is clicked
    suggestionClick(select) {
        this.searchKeyword = select;
        // this.searchKeyword = '';
        this.selectedMobSearchParts = select;
        this.openMobSearchParts = false;
        this.searchProduct();
    },

    //When enter pressed on the input
    keywordMobSearch() {
      // console.log(this.api_results);
        // this.selectedMobSearchParts = this.api_results[this.current];
        // this.searchkeyword = this.api_results[this.current];
        // this.openMobSearchParts = false;
        this.$router.push('/keyword-search-results/' + this.searchkeyword);
    },

    selectedVehicleComplete(){
      const selectedcat = this.$store.getters['vehicle/selectedcategories'];
      if(selectedcat.length !== 0){
          this.$router.push("/search-results");
      }else{
          this.$router.push("/select-parts-drilldown");
      }
    }
  },

  updated () {
    this.isLoggedIn = this.$store.getters.userIsAuthenticated;
    // console.log(this.isLoggedIn);
  },

  created() {
    if(this.appInitialiazed == true){
      this.getCategories();
      this.getMenus();
      this.getIndustrialCat();
      // method from search mixins
      this.getYears();
    }
  }
};
</script>

<style scoped>

  .dropdown-menu {
      position: absolute;
      top: 100%;
      left: 0;
      z-index: 1000;
      display: none;
      float: left;
      min-width: 160px;
      padding: 5px 0;
      margin: 2px 0 0;
      font-size: 14px;
      text-align: left;
      list-style: none;
      background-color: #fff;
      -webkit-background-clip: padding-box;
              background-clip: padding-box;
      border: 1px solid #ccc;
      border: 1px solid rgba(0, 0, 0, .15);
      border-radius: 4px;
      -webkit-box-shadow: 0 6px 12px rgba(0, 0, 0, .175);
              box-shadow: 0 6px 12px rgba(0, 0, 0, .175);
  }

  .dropdown-menu.pull-right {
      right: 0;
      left: auto;
  }
  .dropdown-menu .divider {
      height: 1px;
      margin: 9px 0;
      overflow: hidden;
      background-color: #e5e5e5;
  }
  .dropdown-menu > li > a {
      display: block;
      padding: 3px 20px;
      clear: both;
      font-weight: normal;
      line-height: 1.42857143;
      color: #333;
      white-space: nowrap;
  }
  .dropdown-menu > li > a:hover,
  .dropdown-menu > li > a:focus {
      color: #262626;
      text-decoration: none;
      background-color: #f5f5f5;
  }
  .dropdown-menu > .active > a,
  .dropdown-menu > .active > a:hover,
  .dropdown-menu > .active > a:focus {
      color: #fff;
      text-decoration: none;
      background-color: #337ab7;
      outline: 0;
  }
  .dropdown-menu > .disabled > a,
  .dropdown-menu > .disabled > a:hover,
  .dropdown-menu > .disabled > a:focus {
      color: #777;
  }
  .dropdown-menu > .disabled > a:hover,
  .dropdown-menu > .disabled > a:focus {
  text-decoration: none;
      cursor: not-allowed;
      background-color: transparent;
      background-image: none;
      filter: progid:DXImageTransform.Microsoft.gradient(enabled = false);
  }
  .dropdown-menu.open {
      display: block;
  }
  .open > a {
      outline: 0;
  }
  .dropdown-menu-right {
      right: 0;
      left: auto;
  }
  .dropdown-menu-left {
      right: auto;
      left: 0;
  }
  .dropdown-header {
      display: block;
      padding: 3px 20px;
      font-size: 12px;
      line-height: 1.42857143;
      color: #777;
      white-space: nowrap;
  }
  .dropdown-backdrop {
      position: fixed;
      top: 0;
      right: 0;
      bottom: 0;
      left: 0;
      z-index: 990;
  }
  .pull-right > .dropdown-menu {
      right: 0;
      left: auto;
  }
  .dropup .caret,
  .navbar-fixed-bottom .dropdown .caret {
      content: "";
      border-top: 0;
      border-bottom: 4px dashed;
      border-bottom: 4px solid \9;
  }
  .dropup .dropdown-menu,
  .navbar-fixed-bottom .dropdown .dropdown-menu {
      top: auto;
      bottom: 100%;
      margin-bottom: 2px;
  }

  @media (min-width: 768px) {
    .navbar-right .dropdown-menu {
        right: 0;
        left: auto;
    }
    .navbar-right .dropdown-menu-left {
        right: auto;
        left: 0;
    }
  }
</style>